import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Loader, Table, Dimmer} from 'semantic-ui-react';
import {pageSizes} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import TablePaginator from '../../../../common/components/tablePaginator';
import Item from './item';

class InternalOrderInvoicing extends Component {
  componentDidMount() {
    this.props.changeInternalsOrdersListPage(0);
    this.props.changeInternalsOrdersListPageSize(pageSizes[0].value);
  }

  onPageClick(value) {
    this.props.changeInternalsOrdersListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeInternalsOrdersListPageSize(data.value);
  }

  render() {
    return (
      <div>
        {this.renderLoader()}
        <Table striped>
          {this.renderTableBody()}
          {this.renderTableFooter()}
        </Table>
      </div>
    );
  }

  renderLoader() {
    const {loadingClients, loadingWarehouses, loadingInternalsOrders, invoicing} = this.props;
    const isDisabled = loadingClients || loadingWarehouses || loadingInternalsOrders || invoicing;
    if (!isDisabled) {
      return null;
    }

    const textToShow = this.getTextForLoader();
    return (
      <Dimmer active inverted>
        <Loader inverted content={textToShow} />
      </Dimmer>
    );
  }

  getTextForLoader() {
    const {invoicing} = this.props;
    if (invoicing) {
      return 'Guardando';
    }
    return 'Cargando';
  }

  renderTableBody() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    return (
      <Table.Body>
        {this.renderOrders()}
      </Table.Body>
    );
  }

  renderOrders() {
    const {internalsOrdersList, pageSize, pageNumber} = this.props;
    if (!internalsOrdersList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center'>
            No hay pedidos que cumplan con los criterios de búsqueda
          </Table.Cell>
        </Table.Row>
      );
    }

    return internalsOrdersList.map((element, index) => {
      const position = (pageNumber * pageSize) + index;

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center' className='item-row'>
            <Item item={element} index={position} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableFooter() {
    const {pageSize, totalItems, pageNumber} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick.bind(this)}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick.bind(this)}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInternalsOrders': state.internalOrder.loading,
    'internalsOrdersList': state.internalOrder.internalsOrdersListByPage,
    'totalItems': state.internalOrder.internalsOrdersList.length,
    'pageNumber': state.internalOrder.pageNumber,
    'pageSize': state.internalOrder.pageSize,
    'invoicing': state.invoicing.invoicing,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
})(InternalOrderInvoicing);
